<template>
  <div>
    <swiper :options="options" ref="clubSwiper">
      <slot name="slides"></slot>

      <div class="swiper-prev absolute pin-l pin-t z-10 ml-2 md:mr-8" slot="button-prev">
        <svg class="left-caret-dims text-orange-dark"><use xlink:href="#left-caret"></use></svg>
      </div>
      <div class="swiper-next absolute pin-r pin-t z-10 mr-2 md:ml-8" slot="button-next">
        <svg class="right-caret-dims text-orange-dark"><use xlink:href="#right-caret"></use></svg>
      </div>
    </swiper>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ClubShipment',

  data() {
    return {
      clubs: [],
      options: {
        autoHeight: true,
        roundLengths: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        hashNavigation: {
          watchState: true
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      }
    }
  },

  created() {
    document.addEventListener('lazyloaded', (e) => {
      this.$refs.clubSwiper.swiper.update();
    });
  },

  updated() {
    const hash = document.location.hash.replace('#', '');
    const swiper = this.$refs.clubSwiper.swiper;

    if (hash) {      
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash');
        console.log(slide, slideHash);
        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, 0, swiper.params.runCallbacksOnInit, true);
          swiper.update()
        }
      }
    }
  }
}
</script>

<style>
  .swiper-button-disabled { opacity: 0.2 }

  .swiper-next,
  .swiper-prev {
    top: 40%;
  }

  .or_text {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 0 10%;
  }

  .or_text::before,
  .or_text::after {
    background-color: #dfdbd9;
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin: 1rem 10px;
  }

  @media (min-width: 576px) {
    .or_text {
      flex-direction: column;
      width: auto;
      padding: 0;
      margin: 0 10px;
    }

    .or_text::before,
    .or_text::after {
      width: 1px;
      height: 100%;
      margin: 5px auto;
    }
  }

  .cols {
    columns: 2;
    column-rule: 1px solid #dfdbd9;
    column-gap: 40px;
    column-width: 300px;
  }

  @media (min-width: 1200px) {
    .cols {
      column-gap: 80px;
    }
  }

  .cols p { margin-bottom: 0.75rem; }
  .cols strong { color: #6D6661; }
</style>



// WEBPACK FOOTER //
// _js/components/ClubShipment.vue